// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.create_dashboard__ycfn\\+ {
  width: calc(100% - 200px);
  position: relative;
  left: 200px;
  padding: 20px;
}

.create_cont2__XjqMy {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.create_bodythemelight__wK7Fm {
  background-color: #f3f6f9;
}

.create_bodythemedark__Zhrdl {
  background-color: #151521;
}

.create_headerthemelight__vy5K3 {
  background-color: #fff;
}

.create_headerthemedark__w6SCh {
  background-color: #151521;
}

.create_menuthemelight__eJiEz {
  background-color: #fff;
}

.create_menuthemedark__E2kp3 {
  background-color: #151521;
}

.create_menulinklight__oyAMk {
  color: #60677e !important;
}

.create_menulinklightSelected__yKxxF {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.create_menulinkdarkSelected__t9sjL {
  color: #fff !important;
  border-radius: 10px;
}

.create_menulinkdark__OG2L- {
  color: #60677e !important;
}

.create_menulinklight__oyAMk:hover {
  color: #1d1d1d !important;
}

.create_menulinkdark__OG2L-:hover {
  color: #fff !important;
}

.create_headinglight__uztFz {
  color: #60677e;
}

.create_headingdark__AFijb {
  color: #60677e;
}

.create_searchboxlight__Djoqp {
  background-color: #fff;
  border: none;
}

.create_searchboxdark__hRBIh {
  background-color: #1e1e2d;
  color: #60677e;
}

.create_searchboxdark__hRBIh::placeholder {
  color: #60677e;
}

.create_tableheadlight__v-1lY {
  background-color: #e9eaf0;
}

.create_tableheaddark__uOwkK {
  background-color: #1e1e2d;
  color: #60677e;
}

.create_tablebodylight__cXeKe {
  background-color: #fff;
}
.create_tablebodylight__cXeKe:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.create_tablebodydark__XH\\+H3 {
  background-color: #1e1e2d;
  color: #60677e;
}
.create_tablebodydark__XH\\+H3:hover {
  background-color: #252530;
  cursor: pointer;
}

.create_paginationlight__YE9T1 {
  color: #60677e !important;
  font-size: 13px !important;
}

.create_paginationdark__Z9QUD {
  color: #60677e !important;
  font-size: 13px !important;
}

.create_formthemelight__-tQOc {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.create_formthemedark__8QLkz {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.create_formthemedark__8QLkz ::placeholder {
  color: #60677e;
}

.create_viewformlight__UGAvj {
  background-color: #f3f6f9;
}

.create_viewformdark__CTXe2 {
  background-color: #151521;
}

.create_permissionboxlight__DWgmy {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.create_permissionboxdark__i\\+uee {
  background-color: #151521;
  border: none;
}

.create_errormsgclr__XKJmk {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.create_graphclrlight__n1jf1 {
  background-color: #fff;
}

.create_graphclrdark__-96mQ {
  background-color: #1e1e2d;
}

#create_card1bglight__2ykN6 {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#create_card1bgdark__lJdKQ {
  background: #392f28;
}

#create_card2bglight__eFCtl {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#create_card2bgdark__\\+b3vd {
  background: #1c3238;
}

#create_card3bglight__tZmxz {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#create_card3bgdark__V1ma4 {
  background: #3a2434;
}

#create_card4bglight__1-H58 {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#create_card4bgdark__26\\+vu {
  background: #2f264f;
}

.create_actionbtnlight__FZ2Ip {
  color: rgba(70, 71, 91, 0.8705882353);
}

.create_actionbtndark__mCRPq {
  color: #60677e;
}

.create_profiledropdownlight__zaiQb {
  background-color: #fff;
}

.create_profiledropdowndark__LhjZV {
  background-color: #151521;
}

@media only screen and (max-width: 600px) {
  .create_cont2__XjqMy {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
#create_addform__7yXt7 {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 40px;
  padding-bottom: 80px;
}
#create_addform__7yXt7 .create_permission_title__0RPDX {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
#create_addform__7yXt7 #create_addheading__Pt2AU {
  font-size: 14px;
  font-family: "SFUIDisplay-Medium";
  margin-bottom: 0px;
  margin-left: 5px;
}
#create_addform__7yXt7 .create_inputbox__02NFB {
  padding: 5px 5px 8px 10px;
  border-radius: 5px;
  width: 100%;
  border: 1px solid #ced4da;
  color: #1d1d1d;
  font-size: 14px;
}
#create_addform__7yXt7 .create_inputbox1__ggdTF {
  padding: 5px 5px 8px 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
  font-family: "SFUIDisplayRegular";
}
#create_addform__7yXt7 .create_formlabel__J35f1 {
  font-family: "SFUIDisplayRegular";
  font-size: 14px;
  margin-bottom: 0px;
}
#create_addform__7yXt7 .create_formbtn__P3Pqp {
  background-color: #39979d;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
  margin-bottom: 10px;
  float: left;
}
#create_addform__7yXt7 .create_formbtn__P3Pqp:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#create_addform__7yXt7 .create_resetbtn__CPTof {
  margin-left: 10px;
  background-color: rgba(180, 184, 192, 0.3882352941);
  border: none;
  color: #212529;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#create_addform__7yXt7 .create_resetbtn__CPTof:hover {
  background-color: #dde2eb;
}
#create_addform__7yXt7 ::placeholder {
  font-size: 12px;
}
#create_addform__7yXt7 ul {
  padding-left: 0px;
  display: flex;
  margin-bottom: 0;
}
#create_addform__7yXt7 ul li {
  list-style: none;
  width: 150px;
}
#create_addform__7yXt7 .create_selectlabel__138mq {
  margin-left: 5px;
  font-family: "SFUIDisplayRegular";
  font-size: 14px;
  text-transform: capitalize;
  vertical-align: middle;
}
#create_addform__7yXt7 #create_permissionbox__GRwRF {
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}
#create_addform__7yXt7 .create_arrowback__od8Qh {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#create_addform__7yXt7 .create_arrowback__od8Qh:hover {
  background-color: #39979d;
  color: #fff;
}

@media only screen and (max-width: 878px) {
  #create_addform__7yXt7 ul {
    display: list-item !important;
    list-style: none;
  }
}
@media only screen and (max-width: 600px) {
  #create_dashboardcont2__P0\\+bX {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/create.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADiEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;AClDnB;;ADqEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC3CnB;;ADuEA;EACE,yBAtDgB;ACdlB;;ADwEA;EACE,yBA3DgB;ACVlB;;ADuEA;EACE,yBA7De;ACPjB;;ADwEA;EACE,sBAhEY;ACLd;;ADwEA;EACE,yBAtEe;ACCjB;;ADyEA;EACE,sBAzEY;ACGd;;ADwEA;EACE,yBA9Ee;ACSjB;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EAEE,yBAAA;EACA,mBAAA;ACvEF;;ADyEA;EAEE,sBAAA;EACA,mBAAA;ACvEF;;AD0EA;EACE,yBAAA;ACvEF;;AD0EA;EAEE,yBAAA;ACxEF;;AD0EA;EAEE,sBAAA;ACxEF;;AD4EA;EACE,cA5Ge;ACmCjB;;AD4EA;EACE,cAhHe;ACuCjB;;AD6EA;EACE,sBAvHY;EAwHZ,YAAA;AC1EF;;AD6EA;EACE,yBAvHkB;EAwHlB,cA3He;ACiDjB;;AD4EA;EACE,cA9He;ACqDjB;;AD6EA;EACE,yBA1HiB;ACgDnB;;AD4EA;EACE,yBAnIkB;EAoIlB,cAvIe;AC8DjB;;AD4EA;EACE,sBA7IY;ACoEd;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD4EA;EACE,yBAhJkB;EAiJlB,cApJe;AC2EjB;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD8EA;EACE,yBAAA;EACA,0BAAA;AC3EF;;AD6EA;EACE,yBAAA;EACA,0BAAA;AC1EF;;AD8EA;EACE,sBA1KY;EA2KZ,yBAAA;EACA,qDAAA;AC3EF;;AD6EA;EACE,yBA1KkB;EA2KlB,yBAAA;EACA,eAAA;AC1EF;AD4EE;EACE,cAlLa;ACwGjB;;ADgFA;EACE,yBA9LgB;ACiHlB;;AD+EA;EACE,yBAhMe;ACoHjB;;AD+EA;EACE,yBAAA;EACA,yBAAA;AC5EF;;AD8EA;EACE,yBAAA;EACA,YAAA;AC3EF;;AD8EA;EACE,UAAA;EACA,eAAA;EACA,iCA9Le;EA+Lf,eAAA;AC3EF;;AD+EA;EACE,sBAnNY;ACuId;;AD+EA;EACE,yBAlNkB;ACsIpB;;ADgFA;EACE,mFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADkFA;EACE,qCAAA;AC/EF;;ADkFA;EACE,cAhQe;ACiLjB;;ADoFA;EACE,sBAAA;ACjFF;;ADoFA;EACE,yBAAA;ACjFF;;ADoFA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClFF;AACF;AAhQA;EAEI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAiQJ;AA/PI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAiQR;AA9PI;EACI,eAAA;EACA,iCDyDQ;ECxDR,kBAAA;EACA,gBAAA;AAgQR;AA7PI;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,cDkCM;ECjCN,eAAA;AA+PR;AA7PI;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDuBS;ECtBT,cD0BS;ECzBT,iCDsCS;ACyNjB;AA7PI;EACI,iCDmCS;EClCT,eAAA;EACA,kBAAA;AA+PR;AA7PI;EACI,yBDuBW;ECtBX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA+PR;AA7PY;EACI,2CDaK;ACkPrB;AA5PI;EACI,iBAAA;EACA,mDAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA8PR;AA3PI;EACI,yBAAA;AA6PR;AA1PI;EACI,eAAA;AA4PR;AAzPI;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;AA2PN;AA1PQ;EACI,gBAAA;EACA,YAAA;AA4PZ;AAxPI;EACI,gBAAA;EACA,iCDfS;ECgBT,eAAA;EACA,0BAAA;EACA,sBAAA;AA0PR;AAvPI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAyPR;AAtPI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAwPR;AAtPU;EACE,yBAAA;EACA,WAAA;AAwPZ;;AAjPE;EAEM;IACI,6BAAA;IACA,gBAAA;EAmPV;AACF;AA7OE;EACE;IACI,wBD9CI;IC+CJ,UD9CG;IC+CH,kBAAA;IACA,aDrDW;ECoSjB;AACF","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 200px);\n$dashboardposition: absolute;\n$dashboardleft: 200px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n.menulinklight {\n  color: $lightthemetext !important;\n}\n\n.menulinklightSelected {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 600px) {\n\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n\n    width: 100%;\n    padding: 10px;\n    border-radius: 5px;\n    margin-top: 30px;\n    margin-bottom: 40px;\n    padding-bottom:80px;\n\n    .permission_title{\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n    }\n\n    #addheading{\n        font-size: 14px;\n        font-family: $sffont-medium;\n        margin-bottom: 0px;\n        margin-left: 5px;\n    }\n\n    .inputbox{\n        padding: 5px 5px 8px 10px;\n        border-radius: 5px;\n        width: 100%;\n        border: 1px solid #ced4da;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .inputbox1{\n        padding: 5px 5px 8px 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        color: $lightthemetext;\n        font-family: $sffont-regular;\n    }\n    .formlabel{\n        font-family: $sffont-regular;\n        font-size: 14px;\n        margin-bottom: 0px;\n    }\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n        margin-bottom: 10px;\n        float: left;\n\n            &:hover{\n                background-color: $secondary-btncolor;\n            }\n    }\n    .resetbtn{\n        margin-left: 10px;\n        background-color: #b4b8c063;\n        border: none; \n        color: #212529;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n    }\n\n    .resetbtn:hover{\n        background-color: #dde2eb; \n    }\n\n    ::placeholder{\n        font-size: 12px;\n    }\n\n    ul{\n      padding-left: 0px;\n      display: flex;\n      margin-bottom: 0;\n        li{\n            list-style: none;\n            width: 150px;\n        }\n    } \n\n    .selectlabel{\n        margin-left: 5px;\n        font-family: $sffont-regular;\n        font-size: 14px;\n        text-transform: capitalize;\n        vertical-align: middle;\n    }\n\n    #permissionbox{\n        padding: 10px;\n        margin-bottom: 20px;\n        border-radius: 5px;\n    }\n\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n\n\n  }\n\n  @media only screen and (max-width: 878px) {\n    #addform{\n        ul {\n            display: list-item !important;\n            list-style: none;\n        }\n    }\n  }\n  \n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `create_dashboard__ycfn+`,
	"cont2": `create_cont2__XjqMy`,
	"bodythemelight": `create_bodythemelight__wK7Fm`,
	"bodythemedark": `create_bodythemedark__Zhrdl`,
	"headerthemelight": `create_headerthemelight__vy5K3`,
	"headerthemedark": `create_headerthemedark__w6SCh`,
	"menuthemelight": `create_menuthemelight__eJiEz`,
	"menuthemedark": `create_menuthemedark__E2kp3`,
	"menulinklight": `create_menulinklight__oyAMk`,
	"menulinklightSelected": `create_menulinklightSelected__yKxxF`,
	"menulinkdarkSelected": `create_menulinkdarkSelected__t9sjL`,
	"menulinkdark": `create_menulinkdark__OG2L-`,
	"headinglight": `create_headinglight__uztFz`,
	"headingdark": `create_headingdark__AFijb`,
	"searchboxlight": `create_searchboxlight__Djoqp`,
	"searchboxdark": `create_searchboxdark__hRBIh`,
	"tableheadlight": `create_tableheadlight__v-1lY`,
	"tableheaddark": `create_tableheaddark__uOwkK`,
	"tablebodylight": `create_tablebodylight__cXeKe`,
	"tablebodydark": `create_tablebodydark__XH+H3`,
	"paginationlight": `create_paginationlight__YE9T1`,
	"paginationdark": `create_paginationdark__Z9QUD`,
	"formthemelight": `create_formthemelight__-tQOc`,
	"formthemedark": `create_formthemedark__8QLkz`,
	"viewformlight": `create_viewformlight__UGAvj`,
	"viewformdark": `create_viewformdark__CTXe2`,
	"permissionboxlight": `create_permissionboxlight__DWgmy`,
	"permissionboxdark": `create_permissionboxdark__i+uee`,
	"errormsgclr": `create_errormsgclr__XKJmk`,
	"graphclrlight": `create_graphclrlight__n1jf1`,
	"graphclrdark": `create_graphclrdark__-96mQ`,
	"card1bglight": `create_card1bglight__2ykN6`,
	"card1bgdark": `create_card1bgdark__lJdKQ`,
	"card2bglight": `create_card2bglight__eFCtl`,
	"card2bgdark": `create_card2bgdark__+b3vd`,
	"card3bglight": `create_card3bglight__tZmxz`,
	"card3bgdark": `create_card3bgdark__V1ma4`,
	"card4bglight": `create_card4bglight__1-H58`,
	"card4bgdark": `create_card4bgdark__26+vu`,
	"actionbtnlight": `create_actionbtnlight__FZ2Ip`,
	"actionbtndark": `create_actionbtndark__mCRPq`,
	"profiledropdownlight": `create_profiledropdownlight__zaiQb`,
	"profiledropdowndark": `create_profiledropdowndark__LhjZV`,
	"addform": `create_addform__7yXt7`,
	"permission_title": `create_permission_title__0RPDX`,
	"addheading": `create_addheading__Pt2AU`,
	"inputbox": `create_inputbox__02NFB`,
	"inputbox1": `create_inputbox1__ggdTF`,
	"formlabel": `create_formlabel__J35f1`,
	"formbtn": `create_formbtn__P3Pqp`,
	"resetbtn": `create_resetbtn__CPTof`,
	"selectlabel": `create_selectlabel__138mq`,
	"permissionbox": `create_permissionbox__GRwRF`,
	"arrowback": `create_arrowback__od8Qh`,
	"dashboardcont2": `create_dashboardcont2__P0+bX`
};
export default ___CSS_LOADER_EXPORT___;
